import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import SrvButton from "../../../components/global/SrvButton";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import ErrorAdd from "../../../util/ErrorAdd";

function BlockProviderMaxRemove(props) {
    const { show, onHide, id_type } = props;
    /*
    id_type: 
    ID	Name
    1	Vkontakte
    2	Yandex
    */
    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(false);

    //ОТКРЫТИЕ/ЗАКРЫТИЕ МОДАЛЬНОЕ ОКНО
    useEffect(() => {
        //открытие
        if (show === true) {
            setLog(null);
            setLoading(false)
        }
    }, [show]);

    function removeHandler() {
        setLoading(true);

        axios.post('/api_tracker/bot/maxRemove')
            .then((res) => {
                if (res.data.Status === 1) {
                    onHide();
                }
                else {
                    setLog(res.data.Error);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoading(false);
                ErrorAdd(err, window.location.href);
            });
    }

    return (
        <>
            <Modal show={show} onHide={onHide} >
                <Modal.Body>
                    <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                    <div className="modal_title text-center mb-20">Удаление привязки к Max Bot</div>
                    <div className="text-center mb-20">
                        Подтвердите удаление привязки <b>Max Bot</b>
                    </div>
                    {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                    <div className="row mt-15">
                        <div className="col-md-12 text-center">
                            <SrvButton typeBtn="remove" loading={loading} size={'lg'} onClick={() => removeHandler()} />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
export default BlockProviderMaxRemove;
